import { css } from '@emotion/core';
export var FILL_COLOR = '#FFBC4A';
export var starRating = function starRating() {
  var gap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return /*#__PURE__*/css("display:flex;gap:", gap, "px;align-items:center;");
};
export var starWrapper = {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
};